import React from "react";

import { FormControlLabel } from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import PropTypes from "prop-types";

import RbRadio from "../RbRadio";
import useRbRadioGroupStyles from "./useRbRadioGroupStyles";

const RbRadioGroup = React.forwardRef(function RbRadioGroup(props, ref) {
  const {
    columnGap,
    gridColumns,
    onChange,
    onChangeValue,
    options,
    rowGap,
    ...other
  } = props;

  const classes = useRbRadioGroupStyles(props);

  const handleChange = React.useCallback(
    (event) => {
      if (onChange) {
        onChange(event);
      }
      if (onChangeValue) {
        onChangeValue(event.target.value);
      }
    },
    [onChange, onChangeValue]
  );

  return (
    <RadioGroup {...other} classes={classes} ref={ref} onChange={handleChange}>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          control={<RbRadio />}
          label={option.label}
        />
      ))}
    </RadioGroup>
  );
});

RbRadioGroup.propTypes = {
  columnGap: PropTypes.number,
  gridColumns: PropTypes.number,
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  rowGap: PropTypes.number,
  variant: PropTypes.oneOf(["column", "row", "grid"]),
};

RbRadioGroup.defaultProps = {
  columnGap: 20,
  gridColumns: 4,
  onChange: undefined,
  onChangeValue: undefined,
  options: [],
  rowGap: 0,
  variant: "column",
};

export default React.memo(RbRadioGroup);
